module.exports = __webpack_public_path__ + "static/media/central_department_icon.63986eb0.svg";